import React from 'react';
import {PAGINATION_DEFAULT_LIMIT, API_BASE_URL} from '../../../helpers/constants';
import {Button} from 'reactstrap';
import ReactTable from 'react-table';
import {I18n} from '../../../I18n/components/promoPage';
import Pagination from '../../Pagination/Pagination';
import './applist.css';
import noImg from '../../../assets/images/img-error.svg';

const AppList = props => {
    const {stat, offers} = props;
    let firstElementNumber = props.currentPage * PAGINATION_DEFAULT_LIMIT + 1;
    const tableData = offers.map((offer, index) => {
        return {
            count_id: firstElementNumber++,
            id: offer.id,
            app: {
                name: offer.appLabel,
                id: offer.id
            },
            redirects: stat[offer.appLabels] ? stat[offer.appLabels][0] : 0,
            companies: {
                companies: stat[offer.appLabels] ? stat[offer.appLabels][1]: 0,
                id: offer.id
            },
            actions: (
                <div className="text-center">
                    {/*<Button*/}
                    {/*    onClick={() => props.onPromoApp(offer.id)}*/}
                    {/*    color="inverse"*/}
                    {/*    size="sm"*/}
                    {/*    round="true"*/}
                    {/*    icon="true"*/}
                    {/*    title={`${I18n[props.lang].promo}`}*/}
                    {/*>*/}
                    {/*    <i className="fa fa-percent"/>*/}
                    {/*</Button>*/}
                    <Button
                        onClick={() => props.isDeleteModalToggle(offer.id)}
                        className="ml-1"
                        color="danger"
                        size="sm"
                        round="true"
                        icon="true"
                        title={`${I18n[props.lang].delete}`}
                    >
                        <i className="fa fa-times"/>
                    </Button>
                </div>
            )
        };
    });
    return (
        <div className="app-table MyReactTableClass">
            <ReactTable
                getProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            border: "none",
                            padding: "5px"
                        }
                    };
                }}
                getTheadProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            boxShadow: "none",
                            padding: "10px 0",
                            fontWeight: "600"
                        }
                    };
                }}
                getTheadThProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            borderRight: "none"
                        }
                    };
                }}
                getTdProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            borderRight: "none",
                            textAlign: "center"
                        }
                    };
                }}
                getTrProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            alignItems: "center",
                            minHeight: "45px"
                        }
                    };
                }}
                getNoDataProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            top: "100%"
                        }
                    };
                }}
                columns={[
                    {
                        Header: "#",
                        accessor: "count_id",
                        sortable: false,
                        filterable: false,
                        style: {
                            textAlign: "left",
                            fontSize: "0.8rem",
                            textTransform: "lowercase"
                        },
                        maxWidth: 40
                    },
                    {
                        Header: `${I18n[props.lang].name}`,
                        accessor: "app",
                        sortable: true,
                        filterable: false,
                        minWidth: 200,
                        style: {
                            textAlign: "left",
                            fontSize: "0.8rem",
                        },
                        Cell: row => (
                            <div className="app-table__img">
                                <img
                                    src={`${API_BASE_URL}/trade/offer/icon/${row.value.id}`}
                                    alt="application logotype"
                                    className="img-fluid media-object"
                                    width="30"
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = noImg
                                    }}
                                />
                                <span>{row.value.name}</span>
                            </div>
                        )
                    },
                    {
                        Header: `${I18n[props.lang].redirects}`,
                        accessor: "redirects",
                        sortable: false,
                        filterable: false,
                        maxWidth: 150,
                        style: {
                            fontSize: "0.8rem",
                            textTransform: "lowercase"
                        }
                    },
                    {
                        Header: `${I18n[props.lang].companies}`,
                        accessor: "companies",
                        sortable: false,
                        filterable: false,
                        maxWidth: 150,
                        style: {
                            fontSize: "0.8rem",
                            textTransform: "lowercase"
                        },
                        Cell: row => (
                            <div className="app-table__companies">
                                <span>{row.value.companies}</span>
                                {/*<button className="app-table__companiesBtn" onClick={() =>*/}
                                {/*    props.onShowOffers(row.value.id)}>*/}
                                {/*    <i className="fas fa-arrow-alt-circle-right icon"></i>*/}
                                {/*</button>*/}
                            </div>
                        )
                    },
                    {
                        Header: "",
                        accessor: "actions",
                        sortable: false,
                        filterable: false,
                        maxWidth: 60
                    }
                ]}
                // manualSorting={true}
                // onSortedChange={props.sortBy}
                // defaultSorted={[{
                //     id   : props.sortState.id,
                //     desc : props.sortState.desc,
                // }]}
                // sort={[{id: props.sortState.id, desc: props.sortState.desc}]}
                PaginationComponent={Pagination}
                nextText={">>"}
                previousText={"<<"}
                defaultPageSize={-1}
                pageSize={tableData.length}
                showPaginationBottom={props.totalPages > 1 ? true : false}
                className="-highlight"
                data={tableData}
                filterable
                manual
                onPageChange={props.setCurrentPage}
                page={props.currentPage}
                pages={props.totalPages}
            />
        </div>
    )
};

export default AppList;



// WEBPACK FOOTER //
// ./src/components/Promo/AppList/AppList.js